import { useQueries } from '@tanstack/react-query'
import { TaskApplication } from '../../../pages/superuser/types'
import { getSourceMaps } from '../service/sourceMapService'
import sourceMapQueryKeys from './sourceMapQueryKeys'

const SOURCE_ENTITIES = ['Customer', 'Supplier'] as const

export const useGroupSourceMaps = (companyIds: string[]) =>
  useQueries({
    queries: companyIds.flatMap(companyId =>
      SOURCE_ENTITIES.map(sourceEntity => ({
        queryKey: sourceMapQueryKeys.list({
          companyId,
          source: TaskApplication.FINADECK,
          localEntity: 'Company',
          sourceEntity
        }),
        queryFn: getSourceMaps,
        enabled: !!companyId,
        gcTime: 15 * 60 * 1000
      }))
    ),
    combine: results => ({
      data: results.flatMap(result => result.data ?? []),
      isLoading: results.some(result => result.isLoading),
      isError: results.some(result => result.isError),
      refetch: () => Promise.all(results.map(result => result.refetch()))
    })
  })
